import CustomInput from 'components/common/CustomInput'
import CustomSelect, { ISelectOption } from 'components/common/CustomSelect'
import { useEffect, useState } from 'react'
import CountryData from 'data/country.json'
import { transportStatusSelect } from 'data/transport'
import { ReactComponent as Reset } from 'assets/common/reset.svg'
import { ISearchInfo, IListSearch } from 'types/transport'
import { useRive } from '@rive-app/react-canvas';
import CustomDatePicker from 'components/common/CustomDatePicker'
import { formatDate } from 'components/function'

const First = ({ searchInfo, setSearchInfo, open, avgScore }: IListSearch) => {
    const [option, setOption] = useState<ISelectOption[]>([])
    const [color, setColor] = useState<string>('#4AD35E')
    const [dateReset, setDateReset] = useState<boolean>(false)
    const { rive, RiveComponent } = useRive({
        src: "/beat1.riv", // Rive 파일 경로
        stateMachines: 'State Machine 1',
        autoplay: true,
    });

    const updateStatus = (value: number) => {
        if (!value) return;
        if (rive) {
            const inputs = rive.stateMachineInputs("State Machine 1");
            if (inputs) {
                const input = inputs[0];

                if (value > 80) input.value = 0;
                else if (value > 60) input.value = 1;
                else input.value = 2;

                if (value > 80) setColor('#4AD35E');
                else if (value > 60) setColor('#F8A300');
                else setColor('#FF4D4D');
            }
        }
    };

    useEffect(() => {
        (avgScore && avgScore > 0 && rive) && updateStatus(avgScore)
    }, [avgScore, rive])

    useEffect(() => {
        const mapped: ISelectOption[] = CountryData.map(item => ({
            value: item.id || '',
            label: item.ko,
            labelEn: item.en
        }));

        setOption(mapped);
    }, [])

    const reset = () => {
        setSearchInfo({
            page: 1,
            pageSize: 10
        } as ISearchInfo);
        setDateReset(true)
    }

    return (
        <>
            <div className='flex tablet:justify-between items-center gap-5 tablet:gap-0'>
                <p className='font-semibold tablet:text-xl text-3xl'>진행 현황</p>
                {/* {
                    (user.useSolomon &&
                        avgScore && avgScore > 0) ?
                        <div
                            className={`flex items-center justify-center gap-3 px-3 border rounded h-14 bg-white cursor-pointer tablet:gap-1 tablet:px-2`}
                            style={{ borderColor: color }}
                            onClick={() => {
                                open?.();
                            }}
                        >
                            <div className=''>
                                <p className='font-semibold text-sm'>PULSE SCORE</p>
                                <p className='text-[#9D9EB7] text-xs'>AVERAGE</p>
                            </div>
                            <Bar className='tablet:hidden' />
                            <div className='flex items-center gap-0.5'>
                                <p
                                    className={`digital text-32`}
                                    style={{ color: color }}
                                >
                                    {avgScore}
                                </p>
                                <div className='flex flex-col justify-center items-center gap-0.5 text-[#9D9EB7] text-xs'>
                                    <Heart fill={color} />
                                    <p className='leading-none'>BPM</p>
                                </div>
                            </div>

                            <RiveComponent
                                height={24}
                                width={80}
                                className='w-20 h-12'
                            />
                        </div> :
                        <div className='h-14'></div>
                } */}
            </div>

            <div className='bg-white rounded-lg'>
                <div className='flex items-center px-10 tablet:px-4 border-b-1 w-full h-20 tablet:h-14'>
                    <p className='font-semibold tablet:text-lg text-2xl'>검색 </p>
                </div>
                <div className='flex tablet:flex-col gap-6 tablet:gap-3 px-10 tablet:px-4 py-6 tablet:py-4'>
                    <div>
                        {/* 견적수락일 */}
                        <CustomDatePicker
                            onChange={(value: Date | null | [Date | null, Date | null]) => {
                                if (Array.isArray(value) && value.every(v => v !== null)) {
                                    const [start, end] = value;
                                    setSearchInfo(p => ({
                                        ...p,
                                        fromDate: formatDate(start),
                                        toDate: formatDate(end),
                                        page: 1
                                    }))
                                }
                                else if (Array.isArray(value) && value.every(v => v === null)) {
                                    reset()
                                }
                            }}
                            isRange={true}
                            isMaxToday={true}
                            isReset={dateReset}
                            setIsReset={setDateReset}
                        />
                    </div>

                    <div className='w-[180px]'>
                        <CustomSelect
                            height={60}
                            fontSize={14}
                            option={transportStatusSelect}
                            value={
                                searchInfo.status
                                    ? transportStatusSelect.find(arr => arr.value === searchInfo.status)
                                    : null
                            }
                            placeholder={'상태선택'}
                            onChange={(value) => {
                                setSearchInfo(p => ({
                                    ...p,
                                    status: value,
                                    page: 1
                                }))
                            }}
                        />
                    </div>

                    <div className='w-[180px]'>
                        <CustomSelect
                            height={60}
                            fontSize={14}
                            option={option}
                            value={
                                searchInfo.origin
                                    ? option.find(arr => arr.value === searchInfo.origin)
                                    : null
                            }
                            placeholder={'출발국가'}
                            onChange={(value) => {
                                setSearchInfo(p => ({
                                    ...p,
                                    origin: value,
                                    page: 1
                                }))
                            }}
                        />
                    </div>

                    <div className='w-[180px]'>
                        <CustomSelect
                            height={60}
                            fontSize={14}
                            option={option}
                            value={
                                searchInfo.destination
                                    ? option.find(arr => arr.value === searchInfo.destination)
                                    : null
                            }
                            placeholder={'도착국가'}
                            onChange={(value) => {
                                setSearchInfo(p => ({
                                    ...p,
                                    destination: value,
                                    page: 1
                                }))
                            }}
                        />
                    </div>

                    <div className='w-[320px]'>
                        <CustomInput
                            type="text" height={15} fontSize={'sm'} placeholder="검색어를 입력해주세요"
                            value={searchInfo.title ?? ''}
                            onChange={(e) => {
                                setSearchInfo(p => ({
                                    ...p,
                                    title: e.target.value,
                                    page: 1
                                }))
                            }}
                        />
                    </div>

                    {
                        Object.entries(searchInfo)
                            .filter(([key]) => key !== 'page' && key !== 'pageSize') // page 제외
                            .some(([, value]) => value !== '' && value !== null) && (
                            <div
                                className='group flex justify-center items-center border rounded-md w-15 h-15 overflow-hidden cursor-pointer'
                                onClick={reset}
                            >
                                <Reset className='group-hover:scale-120 transition-all' />
                            </div>
                        )
                    }
                </div>
            </div>
        </>
    )
}

export default First